import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=dce20a7e&scoped=true"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"
import style0 from "./edit.vue?vue&type=style&index=0&id=dce20a7e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dce20a7e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dce20a7e')) {
      api.createRecord('dce20a7e', component.options)
    } else {
      api.reload('dce20a7e', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=dce20a7e&scoped=true", function () {
      api.rerender('dce20a7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/after/csg-admin-return/edit.vue"
export default component.exports